import templateUrl from 'emun.salesrep/sales-by-segment.htm';
import AutoQuery from 'servicestack/auto-query/auto-query';
import basicController from 'servicestack/basic.controller.properties';
import resolve from 'ioc/resolve';

class SalesBySegmentController {
  constructor($rootScope) {
    const $ctrl = this;
    basicController($ctrl);

    //The following queries pull the data needed for the table
    //////////select CY1Stats.OrderCount as CurrentYearCount, CY1Stats.OrderSales as CurrentYearSales, LY1Stats.OrderCount as LastYearCount, LY1Stats.OrderSales as LastYearSales,
    //////////  (CY1Stats.OrderCount - LY1Stats.OrderCount) as [OrderCountVar], (((CY1Stats.OrderCount * 100) / LY1Stats.OrderCount) - 100) as [OrderCountVarPercent],
    //////////  (CY1Stats.OrderSales - LY1Stats.OrderSales) as [OrderSalesVar], (((CY1Stats.OrderSales * 100) / LY1Stats.OrderSales) - 100) as [OrderSalesVarPercent]
    //////////from
    //////////  (select count(*) as [OrderCount], SUM(ordertotal) as [OrderSales] from IndividualOrderTotals where totalgroup = '1' and year = '2018') as [CY1Stats],
    //////////  (select count(*) as [OrderCount], SUM(ordertotal) as [OrderSales] from IndividualOrderTotals where totalgroup = '1' and year = '2019') as[LY1Stats]

    //////////select CY1Stats.OrderCount as CurrentYearCount, CY1Stats.OrderSales as CurrentYearSales, LY1Stats.OrderCount as LastYearCount, LY1Stats.OrderSales as LastYearSales,
    //////////  (CY1Stats.OrderCount - LY1Stats.OrderCount) as [OrderCountVar], (((CY1Stats.OrderCount * 100) / LY1Stats.OrderCount) - 100) as [OrderCountVarPercent],
    //////////  (CY1Stats.OrderSales - LY1Stats.OrderSales) as [OrderSalesVar], (((CY1Stats.OrderSales * 100) / LY1Stats.OrderSales) - 100) as [OrderSalesVarPercent]
    //////////from
    //////////  (select count(*) as [OrderCount], SUM(ordertotal) as [OrderSales] from IndividualOrderTotals where totalgroup = '5' and year = '2018') as [CY1Stats],
    //////////  (select count(*) as [OrderCount], SUM(ordertotal) as [OrderSales] from IndividualOrderTotals where totalgroup = '5' and year = '2019') as[LY1Stats]

    //////////select CY1Stats.OrderCount as CurrentYearCount, CY1Stats.OrderSales as CurrentYearSales, LY1Stats.OrderCount as LastYearCount, LY1Stats.OrderSales as LastYearSales,
    //////////  (CY1Stats.OrderCount - LY1Stats.OrderCount) as [OrderCountVar], (((CY1Stats.OrderCount * 100) / LY1Stats.OrderCount) - 100) as [OrderCountVarPercent],
    //////////  (CY1Stats.OrderSales - LY1Stats.OrderSales) as [OrderSalesVar], (((CY1Stats.OrderSales * 100) / LY1Stats.OrderSales) - 100) as [OrderSalesVarPercent]
    //////////from
    //////////  (select count(*) as [OrderCount], SUM(ordertotal) as [OrderSales] from IndividualOrderTotals where totalgroup = '10' and year = '2018') as [CY1Stats],
    //////////  (select count(*) as [OrderCount], SUM(ordertotal) as [OrderSales] from IndividualOrderTotals where totalgroup = '10' and year = '2019') as[LY1Stats]

    //////////select CY1Stats.OrderCount as CurrentYearCount, CY1Stats.OrderSales as CurrentYearSales, LY1Stats.OrderCount as LastYearCount, LY1Stats.OrderSales as LastYearSales,
    //////////  (CY1Stats.OrderCount - LY1Stats.OrderCount) as [OrderCountVar], (((CY1Stats.OrderCount * 100) / LY1Stats.OrderCount) - 100) as [OrderCountVarPercent],
    //////////  (CY1Stats.OrderSales - LY1Stats.OrderSales) as [OrderSalesVar], (((CY1Stats.OrderSales * 100) / LY1Stats.OrderSales) - 100) as [OrderSalesVarPercent]
    //////////from
    //////////  (select count(*) as [OrderCount], SUM(ordertotal) as [OrderSales] from IndividualOrderTotals where totalgroup = '10G' and year = '2018') as [CY1Stats],
    //////////  (select count(*) as [OrderCount], SUM(ordertotal) as [OrderSales] from IndividualOrderTotals where totalgroup = '10G' and year = '2019') as[LY1Stats]

    //var getDataUrl = 'QueryOrderTotalSummaries.json?Sum=CurrentYearCount,LastYearCount,CurrentYearSales,LastYearSales&GroupBy=TotalGroup';

    var getDataUrl = 'QueryOrderTotalSummaries.json?Sum=CustomerCount,SalesTotal&GroupBy=TotalGroup,OrderYear&OrderBy=OrderYear,TotalGroup';

    var context = $ctrl.context || 'rep';
    var repFilter = "";
    if (context !== 'writingRep') {
      if (context !== 'executive') {
        var filterType = "SalesRepID";
        if (context === 'manager') {
          filterType = 'ManagerId';
        }
        if ($ctrl.rep) {
          repFilter = "&" + filterType + "=" + $ctrl.rep.id;
        }
        else {
          repFilter = "&" + filterType + "=" + $ctrl.repId;
        }

      }
    }
    if ($ctrl.repGroup) {
      if ($ctrl.repGroup !== 'ALL') {
        getDataUrl = getDataUrl + '&RepGroupName=' + $ctrl.repGroup;
      }
    }
    if ($ctrl.insideSales) {
      if ($ctrl.insideSales === 'true') {
        getDataUrl = getDataUrl + '&IsInsideSales=true';
      }
    }
    if ($ctrl.context === "writingRep") {
      if ($ctrl.salesRepId) {
        repFilter = "&SalesRepID=" + $ctrl.salesRepId;
      }
      else {
        repFilter = "&WritingRepID=" + $ctrl.writingRepId;
      }
    }
    if (repFilter !== '') {
      getDataUrl = getDataUrl + repFilter;
    }

    var d = new Date();
    var currentYear = d.getFullYear();
    var lastYear = d.getFullYear() - 1;
    var objRow1 = {};
    var objRow2 = {};
    var objRow3 = {};
    var objRow4 = {};

    var TargetArrayObject = {};

    $ctrl.SalesBySegmentCalulatedData = [];
    $ctrl.SalesBySegmentData = new AutoQuery({
      url: getDataUrl,
      autoLoad: true,
      pageSize: 100,
      scrollTop: false,
      onLoaded: function (resultsOrderTotals) {
        resultsOrderTotals.results.forEach(function (OrderTotalItem) {
         
          var percent = 0;

          if (OrderTotalItem.totalGroup === "1") {
            objRow1.Group = "<$1K";
            TargetArrayObject = objRow1;
          } else if (OrderTotalItem.totalGroup === "2") {
            objRow2.Group = "$1-5K";
            TargetArrayObject = objRow2;
          }
          else if (OrderTotalItem.totalGroup === "3") {
            objRow3.Group = "$5-9K";
            TargetArrayObject = objRow3;
          }
          else if (OrderTotalItem.totalGroup === "4") {
            objRow4.Group = "$10K+";
            TargetArrayObject = objRow4;
          }
         

          if (OrderTotalItem.orderYear === lastYear) {
            TargetArrayObject.lastYearCount = OrderTotalItem.sumCustomerCount;
            TargetArrayObject.lastYearSales = Math.round(OrderTotalItem.sumSalesTotal);
          }

          if (OrderTotalItem.orderYear === currentYear) {
            TargetArrayObject.currentYearCount = OrderTotalItem.sumCustomerCount;
            TargetArrayObject.currentYearSales = Math.round(OrderTotalItem.sumSalesTotal);


            //since we know this is second in the order by, calculate the variances
            TargetArrayObject.countVar = TargetArrayObject.currentYearCount - TargetArrayObject.lastYearCount;

            //find the var percent for order counts
            percent = ((TargetArrayObject.currentYearCount / TargetArrayObject.lastYearCount) * 100) - 100;
            if (percent === Infinity) {
              percent = 100;
            }
            else {
              percent = percent.toFixed(2);
            }
            TargetArrayObject.countVarPercent = percent;
            TargetArrayObject.salesVar = Math.round(TargetArrayObject.currentYearSales - TargetArrayObject.lastYearSales);

            //find the var percent for sales totals
            percent = ((TargetArrayObject.currentYearSales / TargetArrayObject.lastYearSales) * 100) - 100;
            if (percent === Infinity) {
              percent = 100;
            }
            else {
              percent = percent.toFixed(2);
            }
            TargetArrayObject.salesVarPercent = percent;

            //push the data for this seqment to the global array
            $ctrl.SalesBySegmentCalulatedData.push(TargetArrayObject);
            
          }

        });//for each loop
      }
    });
  }
}

let SalesBySegment = {
  bindings: {
    repId: '@',
    repGroup: '@',
    context: '@',
    rep: '<',
    insideSales: '@',
    writingRepId: '@',
    salesRepId: '@'
  },
  controller: SalesBySegmentController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};

export default SalesBySegment;